import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

export default function Faq() {
  const { t } = useT();
  const [openIdx, setOpenIdx] = useState(0);
  const FAQS = [1, 2, 3, 4, 5, 6].map((n) => ({ q: t(`faq.q${n}`), a: t(`faq.a${n}`) }));

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 sm:py-32 bg-[#F8F7F3]"
    >
      <div className="max-w-5xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="text-xs uppercase tracking-[0.25em] text-[#899480] font-semibold mb-4 text-center">
          {t("faq.eyebrow")}
        </div>
        <h2 className="font-serif text-4xl sm:text-5xl font-light leading-[1.05] text-[#3F5043] text-center max-w-3xl mx-auto mb-14">
          {t("faq.title.a")} <em className="text-[#875F45]">{t("faq.title.em")}</em>
        </h2>

        <div className="space-y-3">
          {FAQS.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={i}
                data-testid={`faq-item-${i}`}
                className={`rounded-2xl border transition-all duration-300 overflow-hidden ${
                  open
                    ? "bg-[#EDEDEE] border-[#899480]/40"
                    : "bg-[#F8F7F3] border-[#BCB3A6]/30 hover:border-[#899480]/40"
                }`}
              >
                <button
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="w-full flex items-center justify-between text-left p-6 sm:p-7 gap-6"
                  data-testid={`faq-toggle-${i}`}
                  aria-expanded={open}
                  aria-controls={`faq-panel-${i}`}
                >
                  <span className="font-serif text-xl sm:text-2xl text-[#3F5043] leading-snug">
                    {f.q}
                  </span>
                  <span
                    className={`flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center transition-colors ${
                      open
                        ? "bg-[#899480] text-[#F8F7F3]"
                        : "bg-[#EDEDEE] text-[#899480]"
                    }`}
                  >
                    {open ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 sm:px-7 pb-7 text-base sm:text-lg text-[#3F5043]/75 leading-relaxed max-w-3xl">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
